<template>
     <v-tabs elevation="20"    
      style=" " 
      center-active
 
    >
      <v-tab router to="/patient" >Patient</v-tab>
      
      </v-tabs>
            
     
      <v-card  elevation="22"   variant="outlined" class="mx-auto my-8" style="border-color:#0f58b7">
          <v-card-item>
          <v-card-title style="color:#0a42da">Liste des patients</v-card-title>
     <v-card-text>        
<v-container >
    <!-- <v-row  
    align="end"
        no-gutters>
    <v-btn  @click="data={}" route to="/NouveauPatient">Nouveau patient</v-btn>  
  
</v-row> -->

    <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"      
        label="Rechercher"
        single-line
        hide-details
    style="background-color:#0a42da;color:white ;"
      ></v-text-field>
    </v-card-title>
    <v-data-table 
    style="border-color: #0a42da;border-style: solid;border-width: 0.1px;"
      :headers="headers"
      :items="listdata"
      :search="search"
      no-data-text="Pas de données disponible"
      items-per-page-text="Nombre d'elements par page"
    >

         
<template v-slot:[`item.actions`]="{ item,index}">
    <v-btn  flat  route :to="'/viewPatient/'+ item.id">
    <v-icon
        size="small"
        
      >
        mdi-eye
      </v-icon>
      </v-btn>
      <v-btn flat  route :to="'/updatePatient/'+ item.id">
      <v-icon
        size="small"
        class="me-2"
        
      >
        mdi-pencil
      </v-icon>
      </v-btn>
      <v-btn  flat @click="deleteItem(item,index)" v-if="isAdmin()">
      <v-icon
        size="small"
        
      >
        mdi-delete
      </v-icon>
      </v-btn>
    </template>
</v-data-table>
  </v-card>
</v-container>
</v-card-text>
</v-card-item>
</v-card>
</template>

<style >
.v-data-table-footer{
  
  background: linear-gradient(white,#0a42da,#0a42da);;
  color:white
 
}
.hero {
  background:'  tab3.jpg';
  background-size: cover;
  background-repeat: repeat;
  height:300px;
}
td{
  border-style: solid;
  border-width: 0.1px;
  border-color: #0a42da;
 
  
}
input{
    /* border-color: #2a07d8;
    border-style: solid;
    border-width: 0.5px; */
}
th{

  border-color:#0a42da;
  border-style: solid;
  border-width: 0.1px;
  color:white;
  background:linear-gradient(#0a42da,#0a42da,white);;
 
}


</style>
<script>

import http from '../../http.js'

 export default{
    data() {
        return {
         
            creation:false,
            search: '',
            headers: [{ "title": "Nom", "key": "nom" }, { "title": "Prénom", "key": "prenom" }, { "title": "Prestataire", "key": "prestataire" }, { "title": "Médecin", "key": "medecin" }, { "title": "Actions", "key": "actions" }],
            data: {},
            listdata:[]
        };
    },
    computed() {

      
    },
    mounted() {
      this.list()
        
    },
    methods: {
      list(){
        http.get('/api/patient')
        .then(response => {this.listdata = response.data; })
      },

      valider(){
        
      //alert(JSON.stringify(this.data))
       // if(this.$route.params.id ==undefined){
        
          http.post("/api/patient",this.data).then( resp=>{this.listdata.push(resp.data);this.creation=false});
         
        // }else{
        //   alert('update')
        //   axios.put("/api/patient/"+this.$route.params.id,this.data);
       
        // }
       
       
      },
        modifier(item) {
       
          http.get("/api/patient/"+item.id).then(resp=>{this.data=resp.data;if(this.data.civilite=='Homme') {this.classHo=this.classH} else this.classFe= this.classF});
          this.creation=true
        },
        supprimer(item) {
          http.get("/api/patient/" + item.id);
            const index = this.data.indexOf(item);
            this.data.splice(index, 1);
        },
        afficher(item) {
            alert(item.id);
        },
        civility(item){
          this.data.civilite=item;
          if(item=="Homme"){
            return this.classFe=this.class;
          }
          if(item=="Femme"){
            return this.classHo=this.class;
          }
          
        },
        getId(){
            return this.$route.params.id;
        },
        isAdmin(){
            let user =JSON.parse(localStorage.getItem("user"));
           return  user.profil==='admin';
        },
        async deleteItem(item,index){      
          if(confirm('Etes vous sur de la suppresion du patient '+item.nom+" "+item.prenom +' ?')){
            await http.delete("/api/patient/"+item.id)          
            this.listdata.splice(index, 1);
      }
    }
  }

}
</script>